import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
    ActionType,
} from "../services/types/ComponentTypes";

export const screen_109_parts_request: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        fabAction: {
            type: "add",
            screenId: "160",
            action: "modulev1/parts_request_add",
        },
        title: "Parts Request",
        style: {
            backgroundColor: "#F9FAFB",
        },
        childComponents: [
            {
                componentType: LayoutTypes.GROUP,
                style: {
                    backgroundColor: "#ffffff",
                    direction: FlexDirection.COLUMN,
                    borderRadius: 12,
                    padding: 16,
                },
                childComponents: [
                    {
                        componentType: ComponentType.SUMMARY_LIST,
                        titleValue: "parts_request_no",
                        Name: "parts_request_summary",
                        BindValue: "grid_parts_request",
                        SummeryActions: [
                            {
                                Action: {
                                    Action: "Navigate",
                                    Navigate: "modulev1/parts_request_add/<id>",
                                },
                                ActionType: "Edit",
                                ScreenId: "160",
                            },
                            {
                                Action: {
                                    Action: "PDF",
                                    Settings: "parts_request_pdf_view",
                                },
                                ActionType: ActionType.PDF_DOWNLOAD,
                                tooltip: "Download PDF",
                            },
                        ],
                        Form: {
                            Name: "parts_request",
                            TableName: "parts_request",
                            DisplayName: "Parts Request",
                            Query:
                                "SELECT parts_request.id, parts_request.parts_request_no, parts_request.issue_date as created_at, service_job_card.jobcard_no FROM parts_request LEFT JOIN service_job_card ON service_job_card.id=parts_request.parent_id",
                            Fields: [
                                {
                                    IncludeLabel: true,
                                    Label: "id",
                                    BindValue: "id",
                                    Json_Attribute: "id",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: false,
                                    IsPrimary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "No.#",
                                    BindValue: "part_no",
                                    Json_Attribute: "parts_request_no",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Date",
                                    BindValue: "txt_date",
                                    Json_Attribute: "created_at",
                                    componentType: ComponentType.DATE_FIELD,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Jobcard No.",
                                    BindValue: "jobcard_no",
                                    Json_Attribute: "jobcard_no",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                            ],
                        },
                    },
                ],
            },
        ],
    },
];
